import { useMemo } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { isImageResource, isNonImageFileResource } from 'src/data/performance';

import { AttachmentImage } from '../AttachmentImage';
import { AttachmentOther } from '../AttachmentOther';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  resources: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  index: PropTypes.number,
  onAction: PropTypes.func.isRequired,
  isSlim: PropTypes.bool,
};

const defaultProps = {
  className: '',
  index: 0,
  isSlim: false,
};

export const Attachments = ({ className, resources, index, onAction, isSlim }) => {
  const styles = useStyles();

  const hasLotsOfNonImages = useMemo(
    () => resources.filter(isNonImageFileResource).length > 2,
    [resources]
  );

  return (
    <div
      className={cx(styles.root, className, {
        [styles.hasLotsOfNonImages]: hasLotsOfNonImages,
        [styles.isSlim]: isSlim,
      })}
    >
      {resources.map((resource) =>
        isImageResource(resource) ? (
          <AttachmentImage
            className={styles.attachmentImage}
            key={resource.id}
            resource={resource}
            index={index}
            onAction={onAction}
          />
        ) : (
          <AttachmentOther
            className={styles.attachmentOther}
            key={resource.id}
            resource={resource}
            index={index}
            onAction={onAction}
          />
        )
      )}
    </div>
  );
};

Attachments.propTypes = propTypes;
Attachments.defaultProps = defaultProps;
